<div>


  <div class="row dashboard_background ">
    <div class="col m-4">
      <div class="dash-section m-4 p-3">
        <div class="col">
          <h5 class="bold" style="color: #212529;">Dashboard</h5>
        </div>
        <hr />

      <div>
        <div class="row report-cards px-3">
          <div class="col-4">
              <div
                class="new-orders bg-white small-card px-4 m-auto"
                (click)="displayFarmerDetails()"
              >
                <div class="py-4">
                  <div class="mt-2">
                    <h5 class="heading-text">Farmers</h5>
                  </div>
                  <div>
                    <h1 *ngIf="loaded; else elseBlock" class="ml-1 body-text-farmer">
                      {{ totalFarmers | currency: ' ':'symbol':'1.0' }}
                    </h1>
                    <ng-template #elseBlock>
                      <div class="spinner d-flex text-background">
                        <span
                          class="spinner-border spinner-border-md mx-auto"
                          role="status"
                        ></span>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
          </div>
          <div class="col-4">
            <div
              class="payments bg-white small-card px-4"
              (click)="displayFertigationScheduleDetails()"
            >
              <div class="py-4">
                <div class="mt-2">
                  <h5 class="heading-text">Fertigation Schedules</h5>
                </div>
                <div>
                  <h1 *ngIf="loaded; else elseBlock" class="ml-1 body-text">
                    {{ totalFertigation | currency: ' ':'symbol':'1.0' }}
                  </h1>
                  <ng-template #elseBlock>
                    <div class="spinner d-flex text-background">
                      <span
                        class="spinner-border spinner-border-md mx-auto"
                        role="status"
                      ></span>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div
              class="farmers bg-white small-card px-4"
              (click)="displayInquiryDetails()"
            >
              <div class="py-4">
                <div class="mt-2">
                  <h5 class="heading-text">Inquiries</h5>
                </div>
                <div>
                  <h1 *ngIf="loaded; else elseBlock" class="ml-1 body-text">
                    {{ totalInquiries | currency: ' ':'symbol':'1.0' }}
                  </h1>
                  <ng-template #elseBlock>
                    <div class="spinner d-flex text-background">
                      <span
                        class="spinner-border spinner-border-md mx-auto"
                        role="status"
                      ></span>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mx-3">
        <!-- Farmer card details table -->
        <div *ngIf="farmer_details" class="mt-4">
          <div class=" row mb-2">
            <div class="col-md-10">
              <h5 class="bold chart_heading">Farmer Details</h5>
            </div>
            <div class="col">
              <input
                type="text"
                name="searchFarmers"
                placeholder="Search"
                (keyup)="filterFarmerDetails($event)"
              >
            </div>
          </div>
          <table class="table table-bordered table-primary">
            <thead>
              <tr class="text-uppercase">
                <th>#</th>
                <th scope="col">Name</th>
                <th scope="col">Contact</th>
                <th scope="col">State</th>
                <th scope="col">Crop</th>
                <th scope="col">Date joined</th>
              </tr>
            </thead>
            <tbody class="details-row">
              <tr *ngFor="let row of farmerDetailsFilter | paginate: { id: 'paginate1', itemsPerPage: count, currentPage: farmPage };
              let i = index">
                <td>{{ (farmPage - 1) * count + i + 1 }}</td>
                <td>{{row.farmer_name | titlecase}}</td>
                <td>{{row.farmer_phone_number}}</td>
                <td>{{row.state}}</td>
                <td>{{row.crop}}</td>
                <td>{{row.date_joined | date: 'dd/MM/yyyy'}}</td>
              </tr>
            </tbody>
          </table>
          <nav>
            <pagination-controls id="paginate1" (pageChange)="farmPage = $event"></pagination-controls>
          </nav>
        </div>

        <!-- Fertigation card details table -->
        <div *ngIf="schedule_details" class="mt-4">
          <div class=" row mb-2">
            <div class="col-md-10">
              <h5 class="bold chart_heading">Farmer Fertigation Schedule Details</h5>
            </div>
            <div class="col">
              <input
                type="text"
                name="searchSchedules"
                placeholder="Search"
                (keyup)="filterFarmerScheduleDetails($event)"
              >
            </div>
          </div>
          <table class="table table-bordered table-primary">
            <thead>
              <tr class="text-uppercase">
                <th>#</th>
                <th scope="col">Name</th>
                <th scope="col">Contact</th>
                <th scope="col">State</th>
                <th scope="col">Crop</th>
                <th scope="col">Acreage</th>
                <th scope="col">Planting date</th>
                <th scope="col">Date created</th>
              </tr>
            </thead>
            <tbody class="details-row">
              <tr *ngFor="let row of scheduleDetailsFilter | paginate: { id: 'paginate2', itemsPerPage: count, currentPage: fertPage };
              let i = index">
                <td>{{ (fertPage - 1) * count + i + 1 }}</td>
                <td>{{row.farmer_name}}</td>
                <td>{{row.farmer_phone_number}}</td>
                <td>{{row.state}}</td>
                <td>{{row.crop}}</td>
                <td>{{row.garden_size}}</td>
                <td>{{row.planting_date | date: 'dd/MM/yyyy'}}</td>
                <td>{{row.date_created | date: 'dd/MM/yyyy'}}</td>
              </tr>
            </tbody>
          </table>
          <nav>
            <pagination-controls id="paginate2" (pageChange)="fertPage = $event"></pagination-controls>
          </nav>
        </div>

        <!-- Inquiries card details table -->
        <div *ngIf="inquiry_details" class="mt-4">
          <div class=" row mb-2">
            <div class="col-md-8">
              <h5 class="bold chart_heading">Inquiry Details</h5>
            </div>
            <div class="col" style="margin-left: 100px;">
              <button
                class="btn btn-primary btn-sm"
                routerLink="/contacts"
              >
                Record Inquiry
              </button>
            </div>
            <div class="col">
              <input
                type="text"
                name="searchInquiries"
                placeholder="Search"
                (keyup)="filterInquiryDetails($event)"
              >
            </div>
          </div>
          <table class="table table-bordered btn-group">
            <thead>
              <tr class="text-uppercase">
                <th>#</th>
                <th scope="col">Farmer Name</th>
                <th scope="col">Contact</th>
                <th scope="col">State</th>
                <th scope="col">Question</th>
                <th scope="col">Answer</th>
                <th scope="col">Inquiry date</th>
              </tr>
            </thead>
            <tbody class="details-row">
              <tr *ngFor="let row of inquiryDetailsFilter | paginate: { id: 'paginate3', itemsPerPage: count, currentPage: inqPage };
              let i = index">
                <td>{{ (inqPage - 1) * count + i + 1 }}</td>
                <td>{{row.farmer_name}}</td>
                <td>{{row.contact}}</td>
                <td>{{row.state}}</td>
                <td>{{row.question}}</td>
                <td>{{row.answer}}</td>
                <td>{{row.inquiry_date | date: 'dd/MM/yyyy'}}</td>
              </tr>
            </tbody>
          </table>
          <nav>
            <pagination-controls id="paginate3" (pageChange)="inqPage = $event"></pagination-controls>
          </nav>
        </div>
      </div>

      <div>
        <!-- <div class="row px-3 mt-3">
          <div class="col bg-white  m-3">
            <div class="padding-20">
              <h4 class="bold mt-3 text-center">Orders Distribution</h4>
              <div *ngIf="loaded; else elseBlock" class="mt-4"></div>
              <div style="display: block;">
                <canvas
                  baseChart
                  [data]="ordersChartData"
                  [labels]="ordersChartLabels"
                  [chartType]="doughnutChartType"
                  [colors]="doughnutChartColors"
                >
                </canvas>
              </div>
            </div>
          </div>
          <div class="col bg-white m-3">
            <h4 class="bold mt-3 text-center">Stock Available</h4>
            <div *ngIf="loaded; else elseBlock" class="mt-4">
              <canvas
                baseChart
                [data]="doughnutChartData"
                [labels]="doughnutChartLabels"
                [chartType]="doughnutChartType"
                [colors]="doughnutChartColors"
                [options]="options"
              ></canvas>
            </div>
            <ng-template #elseBlock>
              <div class="spinner d-flex mt-5">
                <span
                  class="spinner-border text-primary spinner-border-md mx-auto"
                  role="status"
                ></span>
              </div>
            </ng-template>
          </div>

        </div> -->
        <div *ngIf="!(farmer_details || schedule_details || inquiry_details)">
          <div class="row farmers-vill-distribution  px-3 mt-4">
            <div class="col-6 bg-white">
              <h5 class="bold chart_heading">Total farmers per crop</h5>
              <div  class="mt-4">
                <div *ngIf="loaded; else elseBlock">
                  <canvas
                    baseChart
                    [datasets]="farmerCropDataset"
                    [labels]="farmerCropLabels"
                    [chartType]="farmerCropDataType"
                    [colors]="farmerCropDataColors"
                    [options]="farmerCropDataOptions"
                  ></canvas>
                </div>

                <ng-template #elseBlock>
                  <div class="spinner d-flex text-background">
                    <span
                      class="spinner-border spinner-border-md mx-auto"
                      role="status"
                    ></span>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="col-6 bg-white">
              <div class="padding-15">
                <h5 class="bold chart_heading">Total farmers per state</h5>
                <div  class="mt-4">
                  <div *ngIf="loaded; else elseBlock">
                    <canvas
                      baseChart
                      [datasets]="farmerStateDataset"
                      [labels]="farmerStateLabels"
                      [chartType]="farmerStateDataType"
                      [colors]="farmerStateDataColors"
                      [options]="farmerStateDataOptions"
                    ></canvas>
                  </div>

                  <ng-template #elseBlock>
                    <div class="spinner d-flex text-background">
                      <span
                        class="spinner-border spinner-border-md mx-auto"
                        role="status"
                      ></span>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
          <div class="row px-3 mt-5">
            <div class="col-6">
              <div class="row">
                <div class="col-7 mr-2">
                  <h5 class="bold chart_heading">Downloads</h5>
                </div>
                <div class="col-2 mr-5">
                  <select name="farmerapp" id="farmerapp" class="px-2 py-1" style="outline: none;">
                    <option value="farmerapp">Farmer app</option>
                  </select>
                </div>
                <div class="col-2">
                  <select class="px-2 py-1" style="outline: none;">
                    <option value="active">Active</option>
                  </select>
                </div>
              </div>
              <div class="mt-4">
                <div *ngIf="loaded; else elseBlock">
                  <canvas
                    baseChart
                    [datasets]="downloadsDataSet"
                    [labels]="downldsLabels"
                    [chartType]="downloadsChartType"
                    [options]="downloadsChartOptions"
                    [colors]="downloadsDataColors"
                  >
                  </canvas>
                </div>
                <ng-template #elseBlock>
                  <div class="spinner d-flex text-background">
                    <span
                      class="spinner-border spinner-border-md mx-auto"
                      role="status"
                    ></span>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
